import { isEmpty } from "lodash"

import LAUNCHPAD_SNAPSHOT from "../../../server/libs/launchpadSnapshot" // eslint-disable-line import/no-restricted-paths

// Copied from: https://github.com/purposeindustries/window-or-global/blob/master/lib/index.js
const getWindowOrGlobal = () =>
  (typeof self === "object" && self.self === self && self) ||
  // eslint-disable-next-line no-undef
  (typeof global === "object" && global.global === global && global) ||
  this

const getPaymentConfig = () => {
  const target = getWindowOrGlobal()

  return typeof target !== "undefined" && !isEmpty(target.paymentConfig)
    ? target.paymentConfig
    : LAUNCHPAD_SNAPSHOT
}

export const getUnsupportedCardTypes = () => {
  const pc = getPaymentConfig()
  return Object.entries(pc.payments.card.card_types)
    .filter(([, val]) => !val.enabled)
    .map(card => card[0])
}

export default getPaymentConfig
